import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-4xl mx-auto py-12 px-4 space-y-8">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(-1)}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Zurück
        </Button>

        <div className="space-y-6">
          <div>
            <h1 className="text-4xl font-bold mb-2">Nutzungsbedingungen</h1>
            <p className="text-muted-foreground">Allgemeine Geschäftsbedingungen (AGB) - Zuletzt aktualisiert: Januar 2025</p>
          </div>

          <div className="bg-yellow-50 dark:bg-yellow-950/20 border border-yellow-200 dark:border-yellow-900 rounded-lg p-4 mb-6">
            <p className="text-sm text-yellow-800 dark:text-yellow-200">
              <strong>Hinweis:</strong> Dies ist eine Vorlage für B2B-SaaS. Passen Sie die Inhalte an Ihr Geschäftsmodell an und lassen Sie die AGB von einem Rechtsanwalt prüfen. Ersetzen Sie Platzhalter [IN KLAMMERN].
            </p>
          </div>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">1. Geltungsbereich</h2>
              <p className="text-muted-foreground leading-relaxed">
                Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle 
                Verträge über die Nutzung der Quentari-Plattform (nachfolgend „Plattform") zwischen 
                [FIRMENNAME] (nachfolgend „Anbieter") und dem Kunden (nachfolgend „Kunde" oder „Sie").
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Mit der Registrierung und Nutzung der Plattform akzeptieren Sie diese AGB in ihrer 
                jeweils gültigen Fassung. Abweichende, entgegenstehende oder ergänzende AGB des 
                Kunden werden nur dann und insoweit Vertragsbestandteil, als der Anbieter ihrer 
                Geltung ausdrücklich schriftlich zugestimmt hat.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Diese AGB gelten ausschließlich für Unternehmer im Sinne des § 14 BGB, juristische 
                Personen des öffentlichen Rechts oder öffentlich-rechtliche Sondervermögen.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">2. Vertragsgegenstand und Leistungsbeschreibung</h2>
              <p className="text-muted-foreground leading-relaxed">
                Quentari ist eine cloudbasierte Software-as-a-Service (SaaS)-Plattform für 
                strukturierte Entscheidungsfindung. Die Plattform bietet Tools und Methoden zur 
                Unterstützung von strategischen Entscheidungsprozessen in Organisationen.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Der genaue Leistungsumfang ergibt sich aus der bei Vertragsschluss gewählten 
                Tarifvariante und der aktuellen Leistungsbeschreibung auf unserer Website. Der 
                Anbieter behält sich vor, die Plattform weiterzuentwickeln und den Funktionsumfang 
                zu erweitern oder anzupassen, solange dies die Hauptleistungspflichten nicht 
                wesentlich beeinträchtigt.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">3. Vertragsschluss und Registrierung</h2>
              <p className="text-muted-foreground leading-relaxed">
                Der Vertragsschluss erfolgt durch Registrierung auf der Plattform und Auswahl eines 
                Tarifs. Mit der Registrierung gibt der Kunde ein verbindliches Angebot zum Abschluss 
                eines Nutzungsvertrags ab.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Bei der Registrierung sind vollständige und wahrheitsgemäße Angaben zu machen. Der 
                Kunde ist verpflichtet, Änderungen der angegebenen Daten unverzüglich mitzuteilen.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">4. Preise und Zahlungsbedingungen</h2>
              <p className="text-muted-foreground leading-relaxed">
                Die jeweils aktuellen Preise finden Sie auf unserer Website. Alle Preise verstehen 
                sich zuzüglich der gesetzlichen Umsatzsteuer.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Die Abrechnung erfolgt monatlich oder jährlich im Voraus, je nach gewähltem 
                Abrechnungszyklus. Die Zahlung ist innerhalb von 14 Tagen nach Rechnungsstellung fällig.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">5. Pflichten des Kunden</h2>
              <p className="text-muted-foreground leading-relaxed">
                Der Kunde verpflichtet sich:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>Die Plattform nur zu rechtmäßigen Zwecken zu nutzen</li>
                <li>Keine rechtswidrigen Inhalte zu erstellen oder zu verbreiten</li>
                <li>Keine Urheberrechte oder sonstige Schutzrechte zu verletzen</li>
                <li>Keine schädliche Software hochzuladen</li>
                <li>Keine automatisierten Zugriffe durchzuführen</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">6. Vertragslaufzeit und Kündigung</h2>
              <p className="text-muted-foreground leading-relaxed">
                Der Vertrag wird für die gewählte Mindestlaufzeit geschlossen und verlängert sich 
                automatisch, wenn er nicht fristgerecht gekündigt wird.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Die Kündigungsfrist beträgt 30 Tage zum Ende der jeweiligen Vertragslaufzeit. 
                Die Kündigung muss schriftlich oder per E-Mail erfolgen.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">7. Haftung</h2>
              <p className="text-muted-foreground leading-relaxed">
                Wir haften für Vorsatz und grobe Fahrlässigkeit. Bei leichter Fahrlässigkeit haften 
                wir nur für die Verletzung wesentlicher Vertragspflichten, beschränkt auf den 
                vertragstypisch vorhersehbaren Schaden.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">8. Datenschutz</h2>
              <p className="text-muted-foreground leading-relaxed">
                Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung 
                und den geltenden Datenschutzgesetzen.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">9. Schlussbestimmungen</h2>
              <p className="text-muted-foreground leading-relaxed">
                Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist, soweit 
                gesetzlich zulässig, der Sitz unseres Unternehmens.
              </p>
            </section>

            <div className="bg-muted/50 rounded-lg p-6 mt-8">
              <p className="text-sm text-muted-foreground text-center">
                Stand: Januar 2025 | Bitte lassen Sie diese AGB von einem Rechtsanwalt prüfen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
